export default __webpack_public_path__ + "ui/assets/img/pay-friend-16.svg";